import * as go from 'gojs';
import { getCrusherVSIImage } from 'unitData/Crushers/CrusherVSI/CrusherVSIData';
import { getImageBinding, getIOPort, makeNode } from '../../utils';

const CrusherVSITemplate = makeNode(
  getImageBinding('showCustomModel', getCrusherVSIImage),
  [getIOPort(go.Spot.Bottom, 'output'), getIOPort(go.Spot.Top, 'input')],
);

export default CrusherVSITemplate;
